import { render, staticRenderFns } from "./ReporteVentaPeriodos.vue?vue&type=template&id=77893864&scoped=true"
import script from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
export * from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
import style0 from "./ReporteVentaPeriodos.vue?vue&type=style&index=0&id=77893864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77893864",
  null
  
)

export default component.exports